import {
  initialState,
  Actions,
  State,
  CANCEL_SCHEDULE_TASKS,
  CANCEL_SCHEDULE_TASKS_SUCCESS,
  CANCEL_SCHEDULE_TASKS_ERROR,
  RESET_CANCEL_SCHEDULE_TASKS,
} from "../../types/group/cancel-schedule-tasks";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case CANCEL_SCHEDULE_TASKS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case CANCEL_SCHEDULE_TASKS_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case CANCEL_SCHEDULE_TASKS_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_CANCEL_SCHEDULE_TASKS:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;

